import { apiClient } from "@apis/apiClient";

const feature = "geolayer";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  getByOrg(params: any) {
    return apiClient.get(`/rest/${feature}/`, { params: params });
  },

  getByOrgCheckVisibility(params: any) {
    return apiClient.get(`/rest/${feature}/visibility/`, { params: params });
  },

  // Returns both geolayers (TILE) and site maps (IMAGE) for the map layer selector
  getAllLayersForMapVisibility(params: any) {
    return apiClient.get(`/rest/${feature}/visibility/all`, { params: params });
  },

  getGeolayerById(id: any) {
    return apiClient.get(`/rest/${feature}/${id}`);
  },

  createGeolayer(params: any) {
    return apiClient.post(`/rest/${feature}/`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  updateGeolayer(id: any, params: any) {
    return apiClient.put(`/rest/${feature}/${id}`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  delete(id: any) {
    return apiClient.delete(`/rest/${feature}/${id}`);
  },
};
